export default "__VITE_ASSET__wxrtWAnj__"